type AdDetailHeaderSectionProps = {
  children: React.ReactNode;
};

function AdDetailHeaderSection({ children }: AdDetailHeaderSectionProps) {
  return <div className="flex items-center space-x-2">{children}</div>;
}

export default AdDetailHeaderSection;
